import { ParsedUrlQuery } from 'querystring';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';

import { createPricesEndpoint, getPrices } from '@/server/initState/getPrices';
import { setPrices } from '@/store/prices/actions';
import { Prices } from '@/store/prices/types';
import { getUserData } from '@/utils/apiRequest/getUserData';

export const usePrices = (query: ParsedUrlQuery) => {
	const dispatch = useDispatch();

	const endpoint = createPricesEndpoint(query, query.coupon);

	const { data: prices } = useSWR<Prices | null>(
		endpoint,
		async () => {
			const response = await getPrices(query, getUserData());

			return response;
		},
		{ revalidateOnFocus: false, errorRetryCount: 0 },
	);

	useEffect(() => {
		if (prices) {
			dispatch(setPrices(prices));
		}
	}, [dispatch, prices]);
};
